export default __webpack_public_path__ + "static/media/LineGraph.1c51da98.svg";